import React from 'react';
import { Text } from 'rsuite';
import CheckIcon from '@rsuite/icons/CheckRound';

export interface ReportingStatusProps {
  isCompleted?: boolean;
  below?: boolean;
}

export const ReportingStatus = ({
  isCompleted,
  below,
}: ReportingStatusProps) => {
  return isCompleted ? (
    <span
      className={[
        'bucket-group-wrapper-completed-badge',
        below && 'bucket-group-wrapper-completed-badge--below',
      ]
        .filter(Boolean)
        .join(' ')}
    >
      <CheckIcon
        aria-hidden="true"
        className="bucket-group-wrapper-completed-icon"
        height={16}
      />
      <Text
        as="span"
        size="md"
      >
        Reporting Complete
      </Text>
    </span>
  ) : (
    <Text
      as="i"
      size="md"
      className={[
        'bucket-group-wrapper-subtitle',
        below && 'bucket-group-wrapper-subtitle--below',
      ]
        .filter(Boolean)
        .join(' ')}
    >
      Reporting Incomplete
    </Text>
  );
};
